import { Injectable } from '@angular/core';
import { Auth, signOut, user, User } from '@angular/fire/auth';
import { AppUser, IAppUser } from '../models/app-user.model';
import { Subject } from 'rxjs';
import { SpinnerService } from './spinner.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { IServerResponse, ServerResponse } from '../models/server-response.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public loggedIn: boolean = false;

  public currentFirebaseUser?: User;

  public currentUser?: AppUser;
  public subCurrentUser: Subject<AppUser> = new Subject<AppUser>();

  constructor(
    public auth: Auth,
    private http: HttpClient,
    private spinnerService: SpinnerService,
    private router: Router
  ) {
    user(this.auth).subscribe((_user) => {
      if (_user) {
        console.log('Existe usuario');
        
        this.loggedIn = true;
        this.currentFirebaseUser = _user;
        this.getUser();
      } else {
        console.log('NO Existe usuario');
        this.loggedIn = false;
      }
    });
  }

  /*
   ██████╗ ███████╗████████╗███████╗██╗██████╗ ███████╗██████╗  █████╗ ███████╗███████╗██╗   ██╗███████╗███████╗██████╗
  ██╔════╝ ██╔════╝╚══██╔══╝██╔════╝██║██╔══██╗██╔════╝██╔══██╗██╔══██╗██╔════╝██╔════╝██║   ██║██╔════╝██╔════╝██╔══██╗
  ██║  ███╗█████╗     ██║   █████╗  ██║██████╔╝█████╗  ██████╔╝███████║███████╗█████╗  ██║   ██║███████╗█████╗  ██████╔╝
  ██║   ██║██╔══╝     ██║   ██╔══╝  ██║██╔══██╗██╔══╝  ██╔══██╗██╔══██║╚════██║██╔══╝  ██║   ██║╚════██║██╔══╝  ██╔══██╗
  ╚██████╔╝███████╗   ██║   ██║     ██║██║  ██║███████╗██████╔╝██║  ██║███████║███████╗╚██████╔╝███████║███████╗██║  ██║
   ╚═════╝ ╚══════╝   ╚═╝   ╚═╝     ╚═╝╚═╝  ╚═╝╚══════╝╚═════╝ ╚═╝  ╚═╝╚══════╝╚══════╝ ╚═════╝ ╚══════╝╚══════╝╚═╝  ╚═╝

  */
 /**
  * FUNCTION getFirebaseUser
  * 
  * @returns 
  */
  async getFirebaseUser(): Promise<User | null> {
    return new Promise((resolve, reject) => {
      
      if(this.currentFirebaseUser) {
        resolve(this.currentFirebaseUser);
      } else {
        user(this.auth).subscribe((_user) => {
          if (_user) {
            console.log('Existe usuario');
            
            this.loggedIn = true;
            this.currentFirebaseUser = _user;
            this.getUser();
            resolve(_user);
          } else {
            console.log('NO Existe usuario');
            this.loggedIn = false;
            resolve(null);
          }
        });
      }

    });
    
  }

  /*
   ██████╗ ███████╗████████╗████████╗ ██████╗ ██╗  ██╗███████╗███╗   ██╗
  ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔═══██╗██║ ██╔╝██╔════╝████╗  ██║
  ██║  ███╗█████╗     ██║      ██║   ██║   ██║█████╔╝ █████╗  ██╔██╗ ██║
  ██║   ██║██╔══╝     ██║      ██║   ██║   ██║██╔═██╗ ██╔══╝  ██║╚██╗██║
  ╚██████╔╝███████╗   ██║      ██║   ╚██████╔╝██║  ██╗███████╗██║ ╚████║
   ╚═════╝ ╚══════╝   ╚═╝      ╚═╝    ╚═════╝ ╚═╝  ╚═╝╚══════╝╚═╝  ╚═══╝

  */
 /**
  * FUNCTION getToken
  * 
  * @returns 
  */
  async getToken(): Promise<String> {
    const user = await this.getFirebaseUser();

    const token = await user?.getIdToken();
    
    return token ?? '';
  }

  /*
   ██████╗ ███████╗████████╗██╗   ██╗███████╗███████╗██████╗
  ██╔════╝ ██╔════╝╚══██╔══╝██║   ██║██╔════╝██╔════╝██╔══██╗
  ██║  ███╗█████╗     ██║   ██║   ██║███████╗█████╗  ██████╔╝
  ██║   ██║██╔══╝     ██║   ██║   ██║╚════██║██╔══╝  ██╔══██╗
  ╚██████╔╝███████╗   ██║   ╚██████╔╝███████║███████╗██║  ██║
   ╚═════╝ ╚══════╝   ╚═╝    ╚═════╝ ╚══════╝╚══════╝╚═╝  ╚═╝

  */
 /**
  * FUNCTION getUser
  */
  async getUser() {
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cargando datos de usuario';

    const token = await this.currentFirebaseUser?.getIdToken();
    // console.log('token: ', token);
    
    const urlApi = `${environment.urlApi}/account`;

    try {

      const response = await new Promise<ServerResponse<{ user: IAppUser }>>(
        (resolve, reject) => {
          this.http.get<IServerResponse<{ user: IAppUser }>>(
            urlApi,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": token ?? ''
              }
            }
          ).subscribe({
            next: (
                response: IServerResponse<{ user: IAppUser }>
              ) => resolve(
                new ServerResponse<{ user: IAppUser }>(response)
              ),
            error: (error) => {
              if (error.error) {
                resolve(new ServerResponse(error.error));
              } else {
                reject(error);
              }
            },
          });
        }
      );

      console.log(response);

      if(response.statusCode === 200) {
        this.currentUser = new AppUser(
          response.data?.user!
        );

        this.subCurrentUser.next(this.currentUser);
      }

      console.log(
        this.currentUser,
      );
      

    } catch(error) {
      console.log(error);
    }


    this.spinnerService.loading = false;
    this.spinnerService.message = '';
  }

  /*
  ███████╗██╗ ██████╗ ███╗   ██╗ ██████╗ ██╗   ██╗████████╗
  ██╔════╝██║██╔════╝ ████╗  ██║██╔═══██╗██║   ██║╚══██╔══╝
  ███████╗██║██║  ███╗██╔██╗ ██║██║   ██║██║   ██║   ██║
  ╚════██║██║██║   ██║██║╚██╗██║██║   ██║██║   ██║   ██║
  ███████║██║╚██████╔╝██║ ╚████║╚██████╔╝╚██████╔╝   ██║
  ╚══════╝╚═╝ ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝  ╚═════╝    ╚═╝

  */
 /**
  * FUNCTION signOut
  */
  async signOut() {
    this.spinnerService.loading = true;
    this.spinnerService.message = 'Cerrando sesión';

    await signOut(this.auth);

    this.currentUser = undefined;

    this.spinnerService.loading = false;
    this.spinnerService.message = '';

    sessionStorage.removeItem('user');
    this.loggedIn = false;
    this.router.navigate(['login']);
  }
  
}
